import DuplicateAddressDialog from 'search/dialogs/DuplicateAddressDialog';

export const DUPLICATE_ADDRESS_DIALOG = 'DUPLICATE_ADDRESS_DIALOG';

const dialogs = {
  [DUPLICATE_ADDRESS_DIALOG]: DuplicateAddressDialog,
};

export default dialogs;
